import React, { Component } from 'react';

import LayoutWithHeader from '../../component/layoutWithHeader';
import PageNotFound from '../../component/404';
import RegularAdmin from './model/regularAdmin';
import { getTenantInfo } from '../../api';
import {checkdomain} from "../../utils/utils";

class RegularLogin extends Component{
  constructor(props) {
    super(props);
    this.state = {
      companyName: '',
      headlineColor: '',
      pageNotFound: false,
      logo: ''
    };
  }

  componentWillMount() {
    let tenantname = location.hostname.split('.')[0].split('-')[0];
    if (checkdomain(tenantname)) {
      return this.props.history.push("/admin");
      // return this.setState({pageNotFound: true});
    }
    getTenantInfo({}, {headers: {'tenantname': tenantname}})
      .then(res => {
        this.setState({
          companyName: res.data.companyName,
          logo: res.data.logo,
          headlineColor: res.data.headlineColor
        })
      })
      .catch(err=>{
        console.log(err);
        if (err.message && err.message === "The tenant was not found.") {
          this.setState({pageNotFound: true});
        }
      });
  }

  render() {
    const { companyName, pageNotFound, logo, headlineColor } = this.state;
    if (pageNotFound) {
      return <PageNotFound />;
    }
    return (
      <LayoutWithHeader logo={logo}>
        <RegularAdmin companyName={companyName} headlineColor={headlineColor} />
      </LayoutWithHeader>
    );
  }
}

export default RegularLogin;


// WEBPACK FOOTER //
// ./src/container/regularLogin/index.js